import { useEffect, useState } from 'react';

const TABLET_WIDTH: number = 991.98;
const MOBILE_WIDTH: number = 767.98;

const useMobileScreenDetection = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isMobileStrict, setIsMobileStrict] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(() => window.innerWidth <= TABLET_WIDTH);
      setIsMobileStrict(() => window.innerWidth <= MOBILE_WIDTH);
    };

    // Initially check if the screen is mobile
    handleResize();

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Cleanup the event listener on unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return { isMobile, isMobileStrict };
};

export default useMobileScreenDetection;
